import { Box, Chip, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import * as React from "react";
import { FormField } from "../FormField";
import { maybePadRight } from "../Functions";

export function ReadOnlyDropDownListField(field: FormField) {
  return (
    <React.Fragment key={field.id}>
      <Grid size={{ xs: 12, sm: field.columns || 6 }}>
        <Box sx={{
          width: "100%"
        }}>
          <Typography
            variant="body2"
            sx={(theme) => ({ fontWeight: 500, marginBottom: "4px", color: theme.palette.form?.label })}
          >
            {field.text}
          </Typography>
          <Box
            sx={(theme) => ({
              borderBottom: `1px solid ${theme.palette.form?.readOnly.border}`,
              paddingBottom: "2px",
              minHeight: "24px",
            })}
          >
            <Typography
              variant="body1"
              sx={(theme) => ({ minHeight: "24px", color: theme.palette.form?.readOnly.text })}
            >
              {field.choices?.find((x) => x.value === field.value)?.text || " "}
            </Typography>
          </Box>
        </Box>
      </Grid>
      {maybePadRight(field)}
    </React.Fragment>
  );
}

export function ReadOnlyTextField(field: FormField) {
  return (
    <React.Fragment key={field.id}>
      <Grid size={{ xs: 12, sm: field.columns || 6 }}>
        <Box sx={{
          width: "100%"
        }}>
          <Typography
            variant="body2"
            sx={(theme) => ({ fontWeight: 500, marginBottom: "4px", color: theme.palette.form?.label })}
          >
            {field.text}
          </Typography>
          <Box
            sx={(theme) => ({
              borderBottom: `1px solid ${theme.palette.form?.readOnly.border}`,
              paddingBottom: "2px",
              minHeight: "24px",
            })}
          >
            <Typography
              variant="body1"
              sx={(theme) => ({ minHeight: "24px", color: theme.palette.form?.readOnly.text })}
            >
              {(field.value as string) || " "}
            </Typography>
          </Box>
        </Box>
      </Grid>
      {maybePadRight(field)}
    </React.Fragment>
  );
}

export function ReadOnlyChip(field: FormField) {
  const getOptionLabel = (option: string) =>
    (field.choices || []).find((choice) => choice.id === option)?.text || "";

  return (
    <React.Fragment key={field.id}>
      <Grid size={{ xs: 12, sm: field.columns || 6 }}>
        <Box sx={{
          width: "100%"
        }}>
          <Typography
            variant="body2"
            sx={(theme) => ({ fontWeight: 500, marginBottom: "4px", color: theme.palette.form?.label })}
          >
            {field.text}
          </Typography>
          <Box
            sx={(theme) => ({
              borderBottom: `1px solid ${theme.palette.form?.readOnly.border}`,
              minHeight: "24px",
            })}
          >
            {field.value && (
              <Typography
                variant="body1"
                sx={(theme) => ({ minHeight: "24px", color: theme.palette.form?.readOnly.text })}
              >
                {getOptionLabel(field.value as string)}
              </Typography>
            )}
          </Box>
        </Box>
      </Grid>
      {maybePadRight(field)}
    </React.Fragment>
  );
}

export function ReadOnlyMultipleChips(field: FormField) {
  const getOptionLabel = (option: string) =>
    (field.choices || []).find((choice) => choice.id === option)?.text || "";

  return (
    <React.Fragment key={field.id}>
      <Grid size={{ xs: 12, sm: field.columns || 6 }}>
        <Box sx={{
          width: "100%"
        }}>
          <Typography
            variant="body2"
            sx={(theme) => ({ fontWeight: 500, marginBottom: "4px", color: theme.palette.form?.label })}
          >
            {field.text}
          </Typography>
          <Box
            sx={(theme) => ({
              borderBottom: `1px solid ${theme.palette.form?.readOnly.border}`,
              minHeight: "24px",
            })}
          >
            {(field.value as string[])
              .map((value) => getOptionLabel(value))
              .sort((a, b) => a.localeCompare(b))
              .map((value, index) => (
                <Chip label={value} key={index} sx={{ margin: "3px" }} />
              ))}
          </Box>
        </Box>
      </Grid>
      {maybePadRight(field)}
    </React.Fragment>
  );
}
